import { BankAccount as BaseBankAccount } from '@models/common/bank-account.model';

export class BankAccount extends BaseBankAccount {
    protected static _resource = 'companyManagement/companies/:company/bankAccounts';
}
